<script>

  import { setActiveTab } from './TabView/TabView.svelte';
  import { elementTabs } from './Workspaces/tabStore.js';
      import {sgettext} from '../i18n.js';


  export let focus;
  export let value = null;
  export let label = null;
  let visibleLabel = null;

  $: if (!label) {
    const valueIsEmpty = !Boolean(value !== null && value !== undefined && value.trim ? value.trim() : value);
    visibleLabel = valueIsEmpty ? sgettext('$$ADD$$') : sgettext('$$EDIT_2$$');
  } else {
    visibleLabel = label
  }

  function setActiveTabAndFocusField() {
    elementTabs.set(
      setActiveTab('contextual', $elementTabs, {focus})
    )
  }

</script>

<a
    href="#contextual"
    style="color: #0B6CB3"
    on:click|stopPropagation={setActiveTabAndFocusField}
>
    [{visibleLabel}]
</a>
